import { UserData, UserModel } from '../../app/modules/auth/models/UserModel'
import { apiClient } from '../client'
import type { ChangePasswordRequest } from './auth.api'

/**
 * User-related types
 */


export interface UpdateUserProfileRequest {
  first_name?: string
  last_name?: string
  // Add other updatable fields
}

export interface LoginDevice {
  id: string
  device_name: string
  last_login: string
  // Add other device fields
}

export interface LoginAttempt {
  id: string
  timestamp: string
  ip_address: string
  success: boolean
  // Add other attempt fields
}

/**
 * User API endpoints
 */
export const userApi = {
  /**
   * Get current user profile
   */
  getProfile: async (): Promise<UserModel> => {
    const { data } = await apiClient.get('/auth/users/me/')
    return data
  },
  /**
   * Get current user profile
   */
  getUserData: async (): Promise<UserData> => {
    const { data } = await apiClient.get('/user-profile/me/')
    return data
  },

  /**
   * Update user profile
   */
  updateProfile: async (payload: UpdateUserProfileRequest): Promise<UserModel> => {
    const { data } = await apiClient.patch('/social/customers/me/', payload)
    return data
  },

  /**
   * Change user password
   */
  changePassword: async (payload: ChangePasswordRequest): Promise<{ message: string }> => {
    const { data } = await apiClient.post('/auth/change-password/', payload)
    return data
  },

  /**
   * Get user's logged in devices
   */
  getDevices: async (): Promise<LoginDevice[]> => {
    const { data } = await apiClient.get('/auth/devices/')
    return data
  },

  /**
   * Revoke a device
   */
  revokeDevice: async (deviceId: string): Promise<void> => {
    await apiClient.delete(`/auth/devices/${deviceId}/`)
  },

  /**
   * Get login attempts history
   */
  getLoginAttempts: async (): Promise<LoginAttempt[]> => {
    const { data } = await apiClient.get('/auth/login-attempts/')
    return data
  },

  /**
   * Get user permissions
   */
  getPermissions: async (): Promise<{ permissions: string[] }> => {
    const { data } = await apiClient.get('/auth/users/me/permissions/')
    return data
  },

  /**
   * Mark the user as no longer new (called once when the onboarding tour ends)
   */
  markUserNotNew: async (): Promise<void> => {
    await apiClient.patch('/auth/users/set_new/', { is_user_new: false })
  },
}
